// extracted by mini-css-extract-plugin
export var cardContainer = "_pw-0";
export var cardHeader = "_pw-2";
export var collapsedState = "_pw-3";
export var dragHandle = "_pw-5";
export var dragHandleIcon = "_pw-6";
export var dragging = "_pw-1";
export var titleArea = "_pw-4";